var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg030Edit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19 13C19 12.4477 19.4477 12 20 12C20.5523 12 21 12.4477 21 13V18C21 19.6569 19.6569 21 18 21H6C4.34315 21 3 19.6569 3 18V6C3 4.34315 4.34315 3 6 3H11C11.5523 3 12 3.44772 12 4C12 4.55228 11.5523 5 11 5H6C5.44772 5 5 5.44772 5 6V18C5 18.5523 5.44772 19 6 19H18C18.5523 19 19 18.5523 19 18V13ZM6.99998 12V16C6.99998 16.5523 7.4477 17 7.99998 17H12C12.2658 17.0015 12.5213 16.8972 12.71 16.71L20 9.43C21.3292 8.08267 21.3292 5.91733 20 4.57L19.43 4C18.0659 2.71232 15.9341 2.71232 14.57 4L7.28998 11.29C7.1028 11.4787 6.99845 11.7342 6.99998 12ZM8.99998 12.41L16 5.41C16.562 4.88169 17.438 4.88169 18 5.41L18.56 5.97C19.1091 6.5236 19.1091 7.4164 18.56 7.97L11.56 14.97H8.99998V12.41Z",
    fill: "#8199A6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg030Edit);
export default __webpack_public_path__ + "static/media/030-edit.61313c630e5f23959cb21f1f1c3665e9.svg";
export { ForwardRef as ReactComponent };